// A React error boundary so a render-time throw in one page shows a recoverable
// fallback instead of white-screening the whole SPA. Error boundaries must be
// class components. Used two ways: page-level inside the shell (keyed by route,
// so nav still works and moving to another page resets it) and as a top-level
// backstop around the whole app.

import { Component, type ReactNode } from 'react'

import { Button } from '../design-system/index.js'

interface Props {
  children: ReactNode
  /** Optional custom fallback; defaults to the centered "algo salió mal" card. */
  fallback?: ReactNode
}
interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  override componentDidCatch(error: unknown): void {
    // Surface the real error so we can see WHAT broke, not just the fallback.
    console.error('[error-boundary]', error)
  }

  override render(): ReactNode {
    if (!this.state.hasError) return this.props.children
    if (this.props.fallback !== undefined) return this.props.fallback
    return (
      <div className="flex min-h-[50vh] w-full items-center justify-center p-6">
        <div className="flex max-w-md flex-col items-center gap-3 text-center">
          <span aria-hidden className="text-[28px]">
            😕
          </span>
          <h2 className="text-[15px] font-bold text-text">Algo salió mal</h2>
          <p className="text-[13px] leading-relaxed text-text-2">
            Ocurrió un error inesperado en esta pantalla. Recarga la página; si vuelve a pasar,
            escríbele a tu equipo INHERTA.
          </p>
          <Button className="mt-1" onClick={() => window.location.reload()}>
            Recargar la página
          </Button>
        </div>
      </div>
    )
  }
}
